var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgHightlights = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M85.644 80H10"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M82.107 74.667V64.458H65.052v10.209"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M82.107 74.667V64.458H65.052v10.209"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M64.7 74.666V50.518H47.647v24.148"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M64.7 74.666V50.518H47.647v24.148"
  }), React.createElement("path", {
    fill: color,
    d: "M47.648 74.666V24.184H30.592v50.482"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M47.648 74.666V24.184H30.592v50.482"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M30.59 74.667V38.526H13.537v36.141"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M30.59 74.667V38.526H13.537v36.141"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M69.323 43.29c7.26 0 13.145-5.884 13.145-13.145 0-7.26-5.885-13.145-13.145-13.145s-13.146 5.885-13.146 13.145 5.886 13.146 13.146 13.146Z"
  }), React.createElement("path", {
    fill: color,
    d: "m64.777 28.61 4.54-4.614 4.542 4.614"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m64.777 28.61 4.54-4.614 4.542 4.614M69.32 23.996V36.29"
  }));
};
export default SvgHightlights;